import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Minus = ({ height, width, fill, className }) => {
  return (
    <svg
      id="minus"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 21 5"
      xmlns="http://www.w3.org/2000/svg"
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M0.999632 0.841949H20.0001C20.5515 0.841949 21.0005 1.28974 21.0005 1.84217V3.15809C21.0005 3.71009 20.5515 4.15789 20.0001 4.15789H0.999632C0.448282 4.15789 -0.000793457 3.71009 -0.000793457 3.15809V1.84217C-0.000793457 1.28974 0.448282 0.841949 0.999632 0.841949Z"/>
    </svg>
  );
};
/* eslint-enable max-len */
Minus.defaultProps = {
  className: null,
};

Minus.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Minus;
